<template>
  <div class="mb-4">
    <label class="form-label" v-if="name !== ''">{{ name }}: {{ description }}</label>

    <slot v-bind:details="details">
      <p v-if="!!details">{{ details }}</p>
    </slot>

    <div
      :class="{ imageManager__imageContainer: layout === 'v1' }"
      :style="displaySize"
    >
      <template v-if="layout === 'v1' || hasUrl">
        <img
          :alt="`${name} ${hasUrl ? 'image' : 'placeholder image'}`"
          :class="name === 'HorizontalLogo' ? 'bw-img-fit' : 'bw-img-fluid'"
          :src="computedSrc"
        />
      </template>
      <template v-else-if="layout === 'v2'">
        <div
          class="image-placeholder d-flex justify-content-center cursor"
          @click.prevent="select"
        >
          <div class="d-flex flex-column justify-content-center">
            <div>
              <div class="full-width text-center">
                <v-icon style="font-size: 120px">mdi-image-filter-hdr</v-icon>
              </div>
              <div class="full-width text-center">
                <a class="text-primary" href="" @click.prevent="select">
                  Upload Image
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div>
      <button
        v-if="!hasUrl && layout === 'v1'"
        class="btn btn-success btn-sm m-1"
        type="button"
        @click="select"
      >
        <i class="fa fa-plus mr-2"></i>
        Select
        <template v-if="hasUrl">
          <template v-if="layout === 'v1'">
            <i class="fa fa-sync mr-2"></i>
            Change
          </template>
          <template v-else-if="layout === 'v2'">Edit</template>
        </template>
      </button>
      <button
        v-if="hasUrl"
        class="btn btn-success btn-sm m-1"
        type="button"
        @click="select"
      >
        <template v-if="layout === 'v1'">
          <i class="fa fa-sync mr-2"></i>
          Change
        </template>
        <template v-else-if="layout === 'v2'">Edit</template>
      </button>
      <button
        v-if="hasUrl && layout === 'v1'"
        class="btn btn-info btn-sm m-1"
        type="button"
        @click="crop"
      >
        <i class="fa fa-crop mr-2"></i>
        Crop
      </button>
      <button
        v-if="hasUrl"
        class="btn btn-danger btn-sm m-1"
        type="button"
        @click="remove"
      >
        <template v-if="layout === 'v1'">
          <i class="fa fa-times mr-2"></i>
          Remove
        </template>
        <template v-else-if="layout === 'v2'">Delete</template>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BwImageManager',
  props: {
    name: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      required: true,
      default() {
        return '';
      }
    },
    details: {
      default: false
    },
    // [width, height]
    size: {
      type: Array,
      required: true
    },
    previewSize: {
      type: Array
    },
    layout: {
      type: String,
      default: 'v1'
    }
  },
  computed: {
    hasUrl() {
      return !!this.imageUrl;
    },
    computedSrc() {
      return this.hasUrl
        ? this.imageUrl
        : `https://via.placeholder.com/${this.size[0]}x${this.size[1]}`;
    },
    displaySize() {
      if (!this.previewSize) return {};

      const [width, height] = this.previewSize;
      return {
        width,
        height
      };
    }
  },
  methods: {
    select() {
      this.$emit('select', this.mediaData);
    },
    crop() {
      this.$emit('crop', this.mediaData);
    },
    remove() {
      this.$emit('remove', this.mediaData);
    }
  }
};
</script>

<style lang="scss">
.imageManager {
  &__imageContainer {
    max-width: 500px;
  }
}
.image-placeholder {
  width: 100%;
  height: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #6d6e71;
  border-radius: 4px;
  opacity: 1;
}

.bw-img-fluid {
  width: 100%;
  height: auto;
}
.bw-img-fit {
  max-width: 100%;
  max-height: 100%;
}
</style>
